import { Text } from '@vkontakte/vkui';
import React, { type FC, memo, useCallback } from 'react';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { useDuplicatesAnalytic } from 'reactApp/hooks/duplicates/useDuplicatesAnalytic';
import { useDuplicatesRemove } from 'reactApp/hooks/duplicates/useDuplicatesRemove';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './DuplicatesRemoveAllModal.css';

export interface DuplicatesRemoveAllModalProps {
    onClose?(): void;
}

const modal_type = 'remove-all';

export const DuplicatesRemoveAllModal: FC<DuplicatesRemoveAllModalProps> = memo(function DuplicatesRemoveAllModal(props) {
    const { onClose } = props;

    const { handleDuplicatesRemoveAll } = useDuplicatesRemove();

    const analyticData = useDuplicatesAnalytic();

    const renderHeader = useCallback(() => <h3 className={styles.title}>Переместить дубликаты в&nbsp;корзину?</h3>, []);

    const renderContent = useCallback(
        () => <Text className={styles.description}>Останется только лучшее фото&nbsp;&mdash; оно&nbsp;отмечено звёздочкой</Text>,
        []
    );

    const handleClose = useCallback(() => {
        onClose?.();
    }, [onClose]);

    const handleShow = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.duplicates,
            action: 'modal-show',
            modal_type,
            ...analyticData,
        });
    }, [analyticData]);

    const handleClick = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.duplicates,
            action: 'modal-click',
            modal_type,
            action_type: 'clear',
            ...analyticData,
        });

        handleClose();
        handleDuplicatesRemoveAll();
    }, [handleClose, handleDuplicatesRemoveAll, analyticData]);

    const handleCancel = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.duplicates,
            action: 'modal-click',
            modal_type: 'remove-all',
            action_type: 'deny',
            ...analyticData,
        });
    }, [analyticData]);

    return (
        <BaseConfirmDialog
            size="small"
            dataQAId="duplicates-remove-all-modal"
            buttons={[EButtonType.accept, EButtonType.cancel]}
            successButtonText="Переместить"
            cancelButtonText="Не перемещать"
            renderContent={renderContent}
            renderHeader={renderHeader}
            onClose={handleClose}
            onSuccess={handleClick}
            onCancel={handleCancel}
            onShow={handleShow}
        />
    );
});
